import styled from "@emotion/styled";
var Container = /*#__PURE__*/ styled("div", {
    target: "e2bv6xj0"
})("padding:", function(param) {
    var theme = param.theme, hasHeader = param.hasHeader;
    return hasHeader ? theme.spacing[50] : "";
}, ";");
var Element = /*#__PURE__*/ styled("div", {
    target: "e2bv6xj1"
})("margin:", function(param) {
    var theme = param.theme;
    return "".concat(theme.spacing[50], " 0");
}, ";");
var Header = /*#__PURE__*/ styled("div", {
    target: "e2bv6xj2"
})("display:flex;justify-content:space-between;/* On large screens header is displayed in the overlay */\n  ", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{display:none;}");
export { Container, Header, Element };
